var map = {
	"./avatar1.png": 8497,
	"./avatar10.png": 6562,
	"./avatar11.png": 1005,
	"./avatar12.png": 6409,
	"./avatar2.png": 1732,
	"./avatar3.png": 817,
	"./avatar4.png": 4928,
	"./avatar5.png": 3838,
	"./avatar6.png": 7774,
	"./avatar7.png": 103,
	"./avatar8.png": 3495,
	"./avatar9.png": 4808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1609;